// extracted by mini-css-extract-plugin
module.exports = {"title":"DalayDrawModal_title___Gn4f","desc":"DalayDrawModal_desc__6SfvT","buttonArea":"DalayDrawModal_buttonArea__Ms3iP","button":"DalayDrawModal_button__XtPA5"};